import { downloadTranslatedFile, validationSegment, getToken } from "../Connector/Connector";
import { FindTagToInject, TagToHtml } from "../helpers/TagHelper";
import { InsertHTMLOnCaretPosition } from "../helpers/TextSelectionHelpers";
import { HTMLToXLIF } from "../helpers/textCleanerHelper";
import { copyFromSourceSegment, acceptTranslatedSegment } from "../reducers/segments";
import { showReturnDialog, updateStepperState, setAnnonymously } from "../reducers/stateManagmentReducer";
import { updateSourceText } from "../reducers/translateReducer";
import { validateSegment, validationLoading } from "../reducers/validationReducer";
import { updateSegment } from "../reducers/segments";
import axios from "axios";
import { ContactlessOutlined } from "@material-ui/icons";

export const Middleware = (api) => (next) => async (action) => {
  let store = api.getState();
  if (action.type !== undefined) {
    switch (action.type) {
      // Inject html tag where caret is present
      case "segments/injectTagAction": {

        //2. Get segment's tags

        let segment = store.segments.segments.find((x) => x.TargetId === action.payload);
        if (segment === undefined) {
          throw new Error("Segment wasn't found for targetId: " + action.payload);
        }

        let segmentTags = segment.SourceTags;

        //3. Based on that html get tag for injection
        let tag = FindTagToInject(segmentTags);

        if (tag !== null) {
          let htmlTag = TagToHtml(tag);

          let test = InsertHTMLOnCaretPosition(htmlTag);

          let target = document.getElementById("target" + action.payload);
          if (target !== null) {
            target.focus();
          }
          let newDraft = target.innerHTML;
        }

        break;
      }

      case "upload/downloadTrasnlactedFileAction": {
        let segments = store.segments.segments;
        let fileId = store.file.uploadedFile;

        let transUnits = [];

        for (var segment = 0; segment < segments.length; segment++) {
          let specificNotes = fileId.transUnits.find((y) => y.id === segments[segment].TargetId).filterSpecificNotes;
          let obj = {};
          let converted = HTMLToXLIF(segments[segment].TargetTextHtml);
          obj.id = segments[segment].TargetId;
          obj.segmentText = converted;
          obj.description = " ";
          obj.afterCharacter = " ";
          obj.beforeText = " ";
          obj.filterSpecificNotes = specificNotes;

          transUnits.push(obj);
        }
        let model = {
          fileId: fileId.fileId,
          transUnits: transUnits,
        };
        api.dispatch(downloadTranslatedFile(model));
        break;
      }
      case "segments/generateCopySourceAction": {
        let segment = store.segments.segments.find((x) => x.TargetId === action.payload);
        //next(api.dispatch(copyFromSourceSegment({ id: segment.TargetId, text: segment.SourceTextHtml })));
        next(copyFromSourceSegment({ id: segment.TargetId, text: segment.SourceTextHtml }));
        let target = document.getElementById("target" + action.payload);
        if (target !== null) {
          target.focus();
        }
        break;
      }
      case "controlsState/updateStepperState": {
        updateStepperState(action.payload.activeStep);
        next(showReturnDialog(false));
        break;
      }
      case "modelMT/generateUpdateSourceTextAction": {
        let sourceText = store.file.uploadedFile.transUnits;
        let sourseSegments = [];
        for (let st = 0; st < sourceText.length; st++) {
          let obj = {};
          obj.segmentId = sourceText[st].id;
          obj.sourceText = sourceText[st].segmentText;
          sourseSegments.push(obj);
        }
        next(updateSourceText({ targetId: action.payload.targetId, sourceText: sourseSegments, langCode: action.payload.langCode }));
        break;
      }
      case "validationResult/genarateSegmentValidation": {
        let a = action.payload;
        let segment = store.segments.segments.find((x) => x.TargetId === a.id);
        let clearedTargetFromHtml =
            (a.text);
        let souclearedSourceFromHtmlrce = HTMLToXLIF(segment.SourceTextHtml);
        let segmentData = { SourceText: souclearedSourceFromHtmlrce, TargetText: clearedTargetFromHtml, segmentId: action.payload.id };
        const nestField = document.getElementById(`target${a.id + 1}`);
        nestField.focus();
        next(validationLoading());
        api.dispatch(validationSegment(segmentData));
        next(updateSegment({ id: a.id, text: a.text }));

        break;
      }
    }
  }
  return next(action);
};
